import StudentDashboard from "./StudentDashboard";
import { useAuth } from "../../../authContext";
import usePageTitle from "common/usePageTitle";
import PrincipalDashboard from "./PrincipalDashboard/PrincipalDashboard";

function DashboardPage() {
  const { userProfile } = useAuth();

  usePageTitle("Dashboard");

  return (
    <>
      <h2>Dashboard</h2>

      <hr />

      {userProfile?.role === "PRINCIPAL" && <PrincipalDashboard />}
      {userProfile?.role === "TEACHER" && <StudentDashboard />}
      {userProfile?.role === "STUDENT" && <StudentDashboard />}
    </>
  );
}

export default DashboardPage;
